export default __webpack_public_path__ + "2caaaf7bde0ef0ffaf58954476e5039a.jpg";